<template>
    <div class="bar-stack">
      <div
        v-for="(segment, index) in segments"
        :key="index"
        :class="['bar-segment', segment.class, { active: index < activeCount }]"
      ></div>
    </div>
  </template>
  
  <script setup>
  import { computed, defineProps } from 'vue';
  import Constants from "@/helpers/constants";

  
  const props = defineProps({
    heartRate: {
      type: Number,
      required: true,
      default: 0
    },
    hrZone: {
      type: String,
      required: true,
      default: 'Rest'
    }
  });
  
  const activeCount = computed(() => {
    console.log('HRZoneBar props:', props);
    if (props.hrZone === Constants.WORKOUT_ZONES.REST) return 1;
    if (props.hrZone === Constants.WORKOUT_ZONES.WARM_UP) return 2;
    if (props.hrZone === Constants.WORKOUT_ZONES.FAT_BURNING) return 3;
    if (props.hrZone === Constants.WORKOUT_ZONES.AEROBIC) return 4;
    if (props.hrZone === Constants.WORKOUT_ZONES.ANAEROBIC) return 5;
    if (props.hrZone === Constants.WORKOUT_ZONES.EXTREME) return 6;
    return 0; // Default to all segments active if no match
  });
  
  const segments = [
    { class: 'b1' },
    { class: 'b2' },
    { class: 'b3' },
    { class: 'b4' },
    { class: 'b5' },
    { class: 'b6' }
  ];
  </script>
  
  <style scoped>
  .bar-stack {
    display: flex;
    flex-direction: column-reverse;
    gap: 0.5rem;
    align-items: center;
  }
  
  .bar-segment {
    width: 2rem;
    height: 0.3rem;
    /* border-radius: 12px; */
    opacity: 0.1;
    transform: scale(0.95);
    transition: all 0.4s ease;
    /* filter: blur(1px); */
    background-color: #333335;
  }
  
  .active {
    opacity: 1;
    transform: scale(1.05);
    animation: pulseGlow 0.6s ease;
    filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.3));
  }
  
  .b1 { background-color: #8a74e6; }
  .b2 { background-color: #74b8e6; }
  .b3 { background-color: #96f189; }
  .b4 { background-color: #ffe14b; }
  .b5 { background-color: #e57e12; }
  .b6 { background-color: #f11212; }
  
  @keyframes pulseGlow {
    0% { transform: scale(1); filter: drop-shadow(0 0 0 rgba(255,255,255,0)); }
    50% { transform: scale(1.1); filter: drop-shadow(0 0 10px rgba(255,255,255,0.4)); }
    100% { transform: scale(1.05); filter: drop-shadow(0 0 6px rgba(255,255,255,0.3)); }
  }
  
  .score-label {
    color: #fff;
    margin-top: 16px;
    font-size: 18px;
    letter-spacing: 1px;
  }
  </style>
  